import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {saleConsultationActions} from "./saleConsultationSlice";
import {saleApi} from "~/api";

function* fetchSaleConsultationList(action) {
	try {
		const response = yield call(saleApi.eventGets, action.payload);
		yield put(saleConsultationActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch saleConsultation list', error);
		let message = error.message;
		if(error?.response?.data?.message) message = error.response.data.message;
		yield put(saleConsultationActions.fetchDataFailed(message));
	}
}

function* handleSearchDebounce(action) {
	yield put(saleConsultationActions.setFilter(action.payload));
}

export default function* saleConsultationSaga() {
	yield takeLatest(saleConsultationActions.fetchData.type, fetchSaleConsultationList);
	yield debounce(500, saleConsultationActions.setFilterWithDebounce.type, handleSearchDebounce)
}